module.exports = __webpack_public_path__ + "static/martha-stories-inventions-fdb02e4d8571aa3958869ca313561417.mp4";